import {generatePath} from "react-router";
import {makeRequest, Methods} from "./request";
import {api} from "./routes";

// List of methods triggering Questions related api calls

// ---- Get single Question from id
export function get_single_question(id, token) {
    const url = api.domain + generatePath(api.routes.singleQuestion, { id })
    return makeRequest(url, Methods.GET, null, token)
}

// ---- Get Question based on list of LevelAsIds
export function get_questions_from_levelAsIds(data) {
    const url = api.domain + generatePath(api.routes.questionsFromLevelAsIds)
    return makeRequest(url, Methods.POST, data)
}